function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ConnectNodes-1{fill:#ffbe54;stroke:#ffbe54;}.ConnectNodes-1,.ConnectNodes-3{stroke-width:1.4px;}.ConnectNodes-2{fill:none;stroke:#16224a;stroke-width:1.2px;}.ConnectNodes-3{fill:#37beb7;stroke:#37beb7;}.ConnectNodes-4{fill:#16224a;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "ConnectNodes-1",
  cx: 3.51,
  cy: 2.9,
  r: 2
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "ConnectNodes-2",
  cx: 3.6,
  cy: 3.62,
  r: 3
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "ConnectNodes-3",
  cx: 22.5,
  cy: 3.02,
  r: 2
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "ConnectNodes-2",
  cx: 22.7,
  cy: 3.73,
  r: 3
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "ConnectNodes-2",
  x1: 6.35,
  y1: 3.66,
  x2: 18.98,
  y2: 3.69
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "ConnectNodes-4",
  points: "15.99 7.36 15.38 6.7 18.63 3.69 15.39 0.66 16 0 19.96 3.69 15.99 7.36"
});

var SvgConnectNodes = function SvgConnectNodes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ConnectNodes_1",
    "data-name": "ConnectNodes 1",
    viewBox: "0 0 26.3 7.36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnectNodes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ConnectNodes.a25d4c59.svg";
export { ForwardRef as ReactComponent };